﻿<template>
    <q-tab-panel name="EventNoticeboardTab">
        <div class="text-center q-mt-xl" v-if="noticeboardMissing">
            <q-btn outline color="secondary" :label="ts( 'noticeboardOnWeb')" @click="noticeboardOpen"></q-btn>
        </div>

        <q-table flat :rows="entries" :columns="entriesColumns" row-key="name" :rows-per-page-options="[0]" v-else>
            <template v-slot:body="props">
                <q-tr :props="props" :key="`m_${props.row.index}`" :class="{ 'first-row': props.row.files.length > 0 }" no-hover>
                    <q-td v-for="col in props.cols" :key="col.name" :props="props" :class="{ 'smaller': col.name === 'link' }">
                        <a :href="props.row.link" target="_blank" v-if="col.name === 'link'">{{ props.row.link }}</a>
                        <span v-else>{{ col.value }}</span>
                    </q-td>
                </q-tr>
                <q-tr :props="props" :key="`e_${props.row.index}`" class="q-virtual-scroll--with-prev second-row" v-if="props.row.files.length > 0" no-hover>
                    <q-td colspan="2" class="text-left overflow-auto">
                        <div class="flex q-gutter-sm">
                            <q-btn outline class="small-button" color="secondary" v-for="file in props.row.files" @click="getFile( file )">
                                <q-icon name="download" size="16px" class="q-mr-xs" color="secondary" />
                                {{ file.name }}
                                ({{ Math.round( file.size / 1024 ) }} kB)
                            </q-btn>
                        </div>
                    </q-td>
                    <q-td></q-td>
                </q-tr>
            </template>
        </q-table>
    </q-tab-panel>
</template>

<script setup lang="ts">
import apiRequest from "@/network/httpClient"
import { DateFormat, ds, ts } from "@/plugins/i18nFormat"
import { Defaults, Options } from "@model/Setting"
import EventsRepo from "@repo/EventsRepo"
import NoticeboardEntriesRepo from "@repo/NoticeboardEntriesRepo"
import SettingsRepo from "@repo/SettingsRepo"
import { saveAs } from "file-saver"
import { useRepo } from "pinia-orm"
import { computed, ref } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()
const props = defineProps<{ event: any }>()
const event = computed( () => ( props.event ?? useRepo( EventsRepo ).getEvent( String( route.params.eventId ), true ) ) )

const noticeboardEntriesRepo = computed( () => ( useRepo( NoticeboardEntriesRepo ) ) )
const noticeboardMissing = ref( true )

async function updateNoticeboard () {
    noticeboardEntriesRepo.value.update( event.value )
        .then( ( response ) => {
            noticeboardMissing.value = false
        } )
        .catch( err => {
            noticeboardMissing.value = true
        } )
}

updateNoticeboard()

const entries = computed( () => ( noticeboardEntriesRepo.value.orderBy( 'when', 'desc' ).get() ) )

const entriesColumns = ref( [
    {
        name: "description",
        label: ts( 'noticeboardEntry' ),
        field: 'description',
        align: 'left'
    },
    {
        name: "link",
        label: ts( 'noticeboardLink' ),
        field: 'link',
        align: 'left'
    },
    {
        name: "when",
        label: ts( 'when' ),
        field: row => ds( row.when, DateFormat.DateTimeLong ),
        align: 'left'
    }
] )

function noticeboardOpen () {
    window.open( 'http://www.sailing.cz/noticeboard/' + event.value.ctlId, '_blank' )
}

function getFile ( file: string ) {
    apiRequest().get( '/events/' + event.value.ctlId + '/noticeboard/file/' + file.id )
        .then( ( response ) => {
            const blob = new Blob( [ Uint8Array.fromBase64( response.data.content ) ] )

            saveAs( blob, response.data.fileName )
        } )
}
</script>

<style scoped lang="sass">
.smaller
  font-size: 80% !important

.small-button
  font-size: 12px !important

.first-row td
  border-bottom: none
  padding-bottom: 0

.second-row td
  padding-top: 0
  border-top: none
</style>
